import React, {memo} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import {GridProps} from "@mui/material"
import connect from "./connect"

export interface StyledProductGridItemProps extends GridProps {
    injectedAd?: boolean
    $customXxl?: number
    templating: {mainTemplate: string; fallbackTemplate: string}
}

const StyledProductGridItem = memo(({templating, ...props}: StyledProductGridItemProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return <ComponentName {...props} />
})

StyledProductGridItem.displayName = "StyledProductGridItem"

export default connect(StyledProductGridItem)
